export default __webpack_public_path__ + "static/media/Shemite Mercenary Boots.b1941b62.jpg";